<button
    mat-icon-button
    (click)="toggleScheme()"
    [matTooltip]="scheme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'"
>
    @if (scheme === 'dark') {
        <mat-icon [svgIcon]="'heroicons_outline:sun'"></mat-icon>
    } @else {
        <mat-icon [svgIcon]="'heroicons_outline:moon'"></mat-icon>
    }
</button>
